<app-public-page-template [headerTextAlignment]="TEXT_ALIGNMENT.LEFT"
  [headerText]="'Login'"
  [showEnvironmentMessage]="true">
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="form-group form-row">
      <label for="email"><h3>Email Address:</h3></label>
      <div class="form-group input-group">
        <input [ngClass]="{ 'is-invalid': displayError(f.email) }"
          autocomplete="email"
          class="form-control"
          formControlName="email"
          id="email"
          placeholder=""
          type="text"/>
        @if (displayError(f.email)) {
          <div class="invalid-feedback">
            @if (f.email.errors) {
              <div>Valid email address required</div>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-group form-row">
      <label for="password">
        <h3>Password:</h3>
      </label>
      <div class="form-group input-group">
        <input [ngClass]="{ 'is-invalid': displayError(f.password) }"
          autocomplete="current-password"
          class="form-control"
          formControlName="password"
          id="password"
          placeholder=""
          type="password"/>
        @if (displayError(f.password)) {
          <div class="invalid-feedback">
            @if (f.password.errors.required) {
              <div>Password is required</div>
            }
          </div>
        }
      </div>
      <div class="form-group input-group">
        <a [routerLink]="routes.PUBLIC.ACCOUNTRECOVERY.path" class="signup-link">
          <h2>Forgot password?</h2>
        </a>
      </div>
    </div>
    <div class="form-group form-row action-button-group">
      <button [disabled]="loading" class="navy-btn">Log In
      </button>
      <a [routerLink]="routes.PUBLIC.SIGNUP.path" class="signup-link"><h2>Sign Up</h2></a>
    </div>
  </form>
</app-public-page-template>
<ngx-ui-loader></ngx-ui-loader>